var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDataLoaded)?_c('v-app',[(!_vm.isMobile)?_c('desktop-nav-bar'):_vm._e(),(_vm.isMobile)?_c('mobile-nav-bar'):_vm._e(),_c('v-main',[_c('router-view')],1),_c('Footer'),_c('Toast',_vm._b({},'Toast',_vm.$store.state.toastProps,false)),_c('cookie-law',{attrs:{"theme":"base--rounded"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }